import React from 'react'
import PropTypes from 'prop-types'
import Footer from './../../components/_partial/Footer'
import Chat from './../../components/_partial/Chat'
import Social from './../../components/_partial/Social'
import HeaderMenuListTest from './../../containers/HeaderMenuTestContainer'

export const PageLayout = ({ children }) => (
  <div>
    <HeaderMenuListTest />
    <div>
      {children}
    </div>
    <Footer />
    <Chat />
    <Social />
  </div>
)
PageLayout.propTypes = {
  children: PropTypes.node,
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js